import { ScheduleAppointmentButton } from '@/components/ScheduleAppointmentButton'
import { VStack } from '@/ui/core/stack'
import { Text } from '@/ui/core/typography'

const BookAppointmentCTA = () => (
	<VStack className="items-center justify-center" gap={24}>
		<Text className="max-w-56 text-center color-palette_6">
			Looks like you have no upcoming appointments.
		</Text>
		<ScheduleAppointmentButton />
	</VStack>
)

export const SchedulingActions = () => {
	return <BookAppointmentCTA />
}
